<div class="booking-container" *ngIf="!loader && businessListData.length > 0">
    <div class="heading_sert">
      <h3>Produce Bill / Invoice</h3>
  </div>
  <div class="chip_services_list">
    <mat-chip-list class="example-chip">
       <mat-chip (click)="selectBusiness(i)" *ngFor="let item of businessListData; let i =index" [ngClass]="{'Graceful-box-active': item.isSelected == 1}" >{{item.name}}</mat-chip>
 
   </mat-chip-list>
  </div>
      <div class="row">
        <div class="col-md-8">
          <mat-card class="booking-form" *ngIf="selectedBusiness.revenue_model == 1">
            <div class="serv_heading">
              <h3>New bill for {{selectedBusiness.name}}</h3>
              <p>{{selectedBusiness.address_line}}</p>
          </div>
          <div class="form-group">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Name</mat-label>
              <input matInput [(ngModel)]="newbookingData.customerName" type="text" placeholder="Enter name" (keyup)="searchCustomerName($event)" [matAutocomplete]="auto">
              <button
            mat-button
            *ngIf="loaderForAutocomplete"
            matSuffix
            mat-icon-button
            aria-label="Clear"
          >
          <mat-progress-spinner
          diameter="20"
          mode="indeterminate"
          color="accent"
          strokeWidth="3"
          style="width: 20px; height: 20px;"
        > </mat-progress-spinner>
          </button>
              <mat-autocomplete #auto="matAutocomplete">
                <mat-option
                  *ngFor="let item of autocompleteItems"
                  (click)="selectSearchResult(item)"
                >
                  {{ item.name | titlecase }} ({{item.country_code}} {{item.phone}})
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
    
            <div class="c_sectionmj">
             <div class="row">
              <div class="col-sm-3">
                <mat-form-field appearance="outline" class="country-code">
                  <mat-label>Country Code</mat-label>
                  <mat-select
                  [(ngModel)]="selectedCountryCode"
                  required
                  (selectionChange)="onCountrySelected($event)"
                >
                  <mat-select-trigger>
                    {{ selectedCountryCode.flag }} {{ selectedCountryCode.name }}
                        {{ "(" + selectedCountryCode.dial_code + ")" }}
                  </mat-select-trigger>
                  
                  <mat-option>
                    <ngx-mat-select-search
                      noEntriesFoundLabel="no results found"
                      name="countrysearch"
                      placeholderLabel="Enter country name"
                      [formControl]="searchString"
                      (keyup)="onKey()"
                    ></ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let country of countryList" [value]="country">
                    {{ country.flag }} {{ country.name }}
                    {{ "(" + country.dial_code + ")" }}
                  </mat-option>
                </mat-select>
                </mat-form-field>
            </div>
            <div class="col-sm-9">
              <mat-form-field appearance="outline" class="phone-number">
                <mat-label>Phone</mat-label>
                <input [(ngModel)]="newbookingData.customerPh" matInput  placeholder="Enter phone" type="tel" smNumericOnly
                minLength="3"
                maxlength="17">
        <mat-hint style="color: red;
    font-size: 13px;" align="end" *ngIf="newbookingData.customerPh && newbookingData.customerPh != '' &&  newbookingData.customerPh.length < 3 ">Please enter a valid phone number in the range of 3-17.</mat-hint>
              </mat-form-field>
              </div>
            </div>
            </div>
          </div>
          <h3 class="servicet_heading">Service type</h3>
          <div class="form-group service-button">
            <mat-chip-list class="example-chip">
              <mat-chip *ngIf="selectedBusiness.shop_service_status != 2 && getSectionVisibleStatus('shop_invoice_access')" [ngClass]="{ 'Graceful-box-active': selectedServiceType == '1' }" (click)="changeServiceType('1')">Shop service</mat-chip>
                <mat-chip *ngIf="selectedBusiness.home_service_status != 2 && getSectionVisibleStatus('home_invoice_access')" [ngClass]="{ 'Graceful-box-active': selectedServiceType == '0' }" (click)="changeServiceType('0')">Home service</mat-chip>
                <mat-chip *ngIf="selectedBusiness.virtual_service_status != 2 && getSectionVisibleStatus('virtual_invoice_access')" [ngClass]="{ 'Graceful-box-active': selectedServiceType == '2' }" (click)="changeServiceType('2')">Virtual service</mat-chip>
            </mat-chip-list>
              </div>

                <h3 class="servicet_heading">Date and time</h3>
              <div class="form-group date-buttons">
                <mat-chip-list class="example-chip">
                    <mat-chip  [ngClass]="{ 'Graceful-box-active': selectedBookingType == 1 }"
                    (click)="changeChip(1)">Today</mat-chip>
                    <mat-chip  [ngClass]="{ 'Graceful-box-active': selectedBookingType == 4 }"
                    (click)="changeChip(4)">Yesterday</mat-chip>
                    <mat-chip  [ngClass]="{ 'Graceful-box-active': selectedBookingType == 5 }"
                    (click)="onSelectDate()">{{ selectedDate && selectedBookingType == 5 ? (selectedDate | date : "longDate") : "Select Date" }}</mat-chip>
                    <mat-chip [ngClass]="{ 'Graceful-box-active': startTime && endTime }" (click)="onSelectSlot()" style="margin-left: 24px;">{{ (startTime && endTime) ? tConv24(startTime) + ' - ' + tConv24(endTime) : 'Select Slot' }}</mat-chip>
                  </mat-chip-list>
            </div>
<!-- SERVICES -->
      <div class="form-group shop_serv">
        <h3>{{ selectedServiceType == "1" ? "Shop services" : (selectedServiceType == "0" ? "Home services" : "Virtual services") }}</h3>
        <mat-chip-list class="example-chip" *ngIf="serviceList.length > 0">
          <div *ngFor="let item of serviceList">
            <mat-chip
              *ngIf="item.toShow"
              style="height: auto"
              (click)="selectServices(item)"
              >{{ item.serviceName }}
            </mat-chip>
          </div>
       

        </mat-chip-list>
        <p *ngIf="serviceList.length == 0">No service added</p>
    </div>

    <!-- PRODUCTS -->
  
    <div class="form-group shop_serv" style="border-top: none;" *ngIf="productsList.length > 0">
      <h3>Sellable products</h3>
      <mat-chip-list class="example-chip" *ngIf="productsList.length > 0">
        <div *ngFor="let item of productsList">
          <mat-chip
            *ngIf="item.toShow"
            style="height: auto"
            (click)="selectProducts(item)"
            >{{ item.product_name }}
          </mat-chip>
        </div>
     

      </mat-chip-list>
      <p *ngIf="productsList.length == 0">No product added</p>
  </div>

<!-- COMPLETED JOBS -->
    <h3 *ngIf="completedJobs.length > 0">Job completed</h3>
    <div class="chip_cont">
      <div class="" *ngIf="completedJobs.length > 0">
       
        <div *ngFor="let item of completedJobs; let i = index;" style="margin-bottom: 30px;display: flex;
        justify-content: space-between;
        align-items: center;border-bottom: 1px solid #ddd;padding-bottom: 25px;">
          <div class="first_div">
            <div style="
                display: inline-block;
                width: fit-content;
                background: #ffc107;
                padding: 7px 12px;
                border-radius: 34px;
                margin-bottom: 20px; ">
              <p style="margin: 0px;font-weight: 500;">
                {{ item.service_name }}
              </p>
            </div>
            <mat-icon style="font-size: 20px;
            font-weight: 900;
            color: #000;
            position: relative;
            top: 4px;
            margin-left: 10px;">close</mat-icon>
            <div style="display: inline-block;">
              <span style="    margin-left: 10px;
              border: 1px solid #a2a2a2;
              padding: 10px;
              border-radius: 10px;">
                <button
                (click)="decreaseServiceCount(item,i)"
                style="background: none;
                border: 1px solid #a2a2a2;
                border-radius: 25px;
                width: 25px;
                height: 25px;">
                <mat-icon class="material-icons-outlined" style="    font-size: 16px;
                position: relative;
                top: 2px;
                left: -3px;
                color: #666666;
                height: auto;
                width: auto;">remove</mat-icon>
                </button>
                <span style="    margin: 0 15px;"> {{item.total_completed_services_qty}} </span>
                <button 
                (click)="increaseServiceCount(item,i)"
                style="background: none;
                border: 1px solid #a2a2a2;
                border-radius: 25px;
                width: 25px;
                height: 25px;">
                <mat-icon style="    font-size: 16px;
                position: relative;
                top: 2px;
                left: -3px;
                color: #666666;
                height: auto;
                width: auto;" class="material-icons-outlined">add</mat-icon>
                </button>
              </span>
              
              
            </div>
            <div *ngIf="selectedBusiness.is_owner == 1" >
                by <span style="
              text-decoration: underline; cursor: pointer;" (click)="assignEmployee(item,i)" >{{item.completed_by | arrayToStr | ellipsify:30}}</span>
  
              <span
              (click)="removeCompletedJobs(item)"
              style="
              margin-left: 20px;
              display: inline-block;
              cursor: pointer;">
                Remove
              </span>
              </div>
            <div *ngIf="selectedBusiness.is_owner == 0" style="
              text-decoration: underline; cursor: pointer;">
                
              <span
              (click)="removeCompletedJobs(item)"
              style="
              margin-left: 20px;
              display: inline-block;
              cursor: pointer;">
                Remove
              </span>
              </div>

          </div>
          <div class="second-div" style="padding: 0;">

            <!-- <div >
              <mat-form-field appearance="outline" style="width: 100px" class="small-height-input">
                <input [(ngModel)]="item.price" matInput smDecimalOnly type="number"  (ngModelChange)="changeServicePrice(item)"/>
              </mat-form-field>
            </div> -->
            <div class="th_heading">
              <input [(ngModel)]="item.price" matInput smDecimalOnly type="number"  (ngModelChange)="changeServicePrice(item)"/>
          </div>
        </div>

        </div>
      </div>
        

      </div>
<!-- COMPLETED PRODUCTS -->
    <h3 *ngIf="completedProducts.length > 0">Products selected</h3>
    <div class="chip_cont">
      <div class="" *ngIf="completedProducts.length > 0">
       
        <div *ngFor="let item of completedProducts; let i = index;" style="margin-bottom: 30px;display: flex;
        justify-content: space-between;
        align-items: center;border-bottom: 1px solid #ddd;padding-bottom: 25px;">
          <div class="first_div">
            <div style="
                display: inline-block;
                width: fit-content;
                background: #ffc107;
                padding: 7px 12px;
                border-radius: 34px;
                margin-bottom: 20px; ">
              <p style="margin: 0px;font-weight: 500;">
                {{ item.product_name }}
              </p>
            </div>
            <mat-icon style="font-size: 20px;
            font-weight: 900;
            color: #000;
            position: relative;
            top: 4px;
            margin-left: 10px;">close</mat-icon>
            <div style="display: inline-block;">
              <span style="    margin-left: 10px;
              border: 1px solid #a2a2a2;
              padding: 10px;
              border-radius: 10px;">
                <button
                (click)="decreaseProductCount(item,i)"
                style="background: none;
                border: 1px solid #a2a2a2;
                border-radius: 25px;
                width: 25px;
                height: 25px;">
                <mat-icon class="material-icons-outlined" style="    font-size: 16px;
                position: relative;
                top: 2px;
                left: -3px;
                color: #666666;
                height: auto;
                width: auto;">remove</mat-icon>
                </button>
                <span style="    margin: 0 15px;"> {{item.total_completed_services_qty}} </span>
                <button 
                (click)="increaseProductCount(item,i)"
                style="background: none;
                border: 1px solid #a2a2a2;
                border-radius: 25px;
                width: 25px;
                height: 25px;">
                <mat-icon style="    font-size: 16px;
                position: relative;
                top: 2px;
                left: -3px;
                color: #666666;
                height: auto;
                width: auto;" class="material-icons-outlined">add</mat-icon>
                </button>
              </span>
              
              
            </div>
            <div style="
              text-decoration: underline; cursor: pointer;">
                <!-- by <span (click)="assignEmployee(item,i)" >{{item.completed_by | arrayToStr | ellipsify:30}}</span> -->
  
              <span
              (click)="removeCompletedProducts(item)"
              style="
              margin-left: 20px;
              display: inline-block;
              cursor: pointer;">
                Remove
              </span>
              </div>

          </div>
          <div class="second-div" style="padding: 0;">

            <!-- <div >
              <mat-form-field appearance="outline" style="width: 100px" class="small-height-input">
                <input [(ngModel)]="item.price" matInput smDecimalOnly type="number"  (ngModelChange)="changeServicePrice(item)"/>
              </mat-form-field>
            </div> -->
            <div class="th_heading">
              <input [(ngModel)]="item.price" matInput smDecimalOnly type="number"  (ngModelChange)="changeProductPrice(item)"/>
          </div>
        </div>

        </div>
      </div>
        

      </div>



      <!-- new section added start -->
      <!-- -->
   
    <!-- <div style="border-bottom: 1px solid lightgray;">
        <div class="row" style="margin-bottom: 20px; padding: 0 18px 0 0">
            <div class="col-sm-10" style="font-size: 16px;">Total</div>
            <div class="col-sm-2" style="text-align: right; font-size: 16px;">
              
    
                  {{newbookingData.price}}
                </div>
         
        </div>
        <div class="row" style="padding: 0 18px 0 0;">
            <div class="col-sm-10" style="font-size: 16px;">Discount</div>
            <div class="col-sm-2" style="text-align: right;">
                <mat-form-field appearance="outline" style="width: 100px" class="small-height-input">
                    <input [(ngModel)]="newbookingData.discount" matInput smDecimalOnly type="number" />
                  </mat-form-field>
                </div>
         
        </div>
       
    </div> -->

    <!-- <div>
        <div class="row" style="margin-top: 20px; margin-bottom: 40px; padding: 0 18px 0 0">
            <div class="col-sm-10" style="font-size: 16px;">Net payable</div>
            <div class="col-sm-2" style="text-align: right; font-size: 16px;">
             
    
                  {{newbookingData.price - newbookingData.discount}}
                </div>
         
        </div>
    </div> -->
    

   <!-- create invice new design added -->
   <div class="other_itemi_secty">
    <div class="oth_headingrt">
      <h3>Other items</h3>
    </div>
    <!-- <div class="repect_under" *ngFor="let item of repeatArray; let i = index">
    <div class="row">
      <div class="col-sm-6">
        <div class="item_name_tht">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Item name</mat-label>
              <input matInput type="text" placeholder="Enter item name">
            </mat-form-field>
        </div>
      </div>

      <div class="col-sm-6">
        
        <div class="plus_tht" style="padding-top: 14px;">
          <mat-icon class="serv_x">close</mat-icon>
          <div class="inc_dec_cont">
            <span class="cont_span">
              <button class="inc_dec_btn">
              <mat-icon >remove</mat-icon>
              </button>
              <span style="margin: 0 15px;"> 1 </span>
              <button 
              class="inc_dec_btn">
              <mat-icon class="material-icons-outlined">add</mat-icon>
              </button>
            </span>
            <span class="remove_btn" (click)="removeFormField(i)">Remove</span>
          </div>
        </div>

      </div>
    </div>
  </div>
 
    <div class="add_item_btbh">
      <button mat-flat-button color="accent" (click)="addFormField()">
        <mat-icon>add</mat-icon>
        Add item
      </button>
    </div> -->

    <form [formGroup]="form">
      <div formArrayName="items">
        <div *ngFor="let item of items.controls; let i = index" [formGroupName]="i" class="repect_under">
          <div class="row">
            <div class="col-sm-3">
              <div class="item_name_tht">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Item name</mat-label>
                  <input matInput formControlName="name" [matAutocomplete]="auto" type="text" placeholder="Enter item name">
                  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayItemName">
                    <mat-option *ngFor="let option of filteredOptions[i] | async" [value]="option">
                      {{ option.item_name }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="plus_tht" style="padding-top: 14px;">
                <mat-icon class="serv_x">close</mat-icon>
                <div class="inc_dec_cont">
                  <span class="cont_span">
                    <button class="inc_dec_btn" type="button"  (click)="decreaseCount(i)">
                      <mat-icon>remove</mat-icon>
                    </button>
                    <span style="margin: 0 15px;">{{ item.get('count')!.value }}</span>
                    <button class="inc_dec_btn" type="button"  (click)="increaseCount(i)">
                      <mat-icon>add</mat-icon>
                    </button>
                  </span>
                </div>
              </div>
            </div>
            <div class="col-sm-3">
              
              <mat-form-field appearance="outline" >
                <mat-select class="w-100" formControlName="tax_slab">
                  <mat-option value="default" >
                    Select a tax
                  </mat-option>
                  <mat-option [value]="item.hash_id" *ngFor="let item of taxSlabData">
                    {{isEntityForeign == '0' ? item.tax_name : item.slab_name}}
                  </mat-option>
                  
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-sm-3">
              <div class="item_name_tht">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Item price</mat-label>
                  <input matInput formControlName="price" type="text" placeholder="Enter item price" smDecimalOnly type="number">
                </mat-form-field>
              </div>
            </div>
            <span class="remove_btn" >
              <a (click)="removeFormField(i)"> Remove</a> 
             </span>
          </div>
        </div>
      </div>
    
      <div class="add_item_btbh">
        <button type="button" mat-flat-button color="accent" (click)="addFormField()">
          <mat-icon>add</mat-icon>
          Add item
        </button>
      </div>
    </form>
    

  </div>


  <!-- create invice new design end -->


     <div class="new_prodcutht">
        <div class="tota_price_s">
            <div class="th_heading">
                <p class="tog_section">Total</p>
            </div>
            <div class="th_heading">
                <p class="tog_section">{{newbookingData.price.toFixed(2)}}</p>
            </div>
        </div>

        <div class="tota_price_s">
            <div class="th_heading">
                <p class="tog_section">Discount</p>
            </div>
            <div class="th_heading">
                <input [(ngModel)]="newbookingData.discount" smDecimalOnly type="number" matInput />
            </div>
        </div>
     </div>
     <div class="net_payble_se">
        <div class="tota_price_s">
            <div class="th_heading">
                <p>Net payable</p>
            </div>
            <div class="th_heading">
                <p>{{(newbookingData.price - newbookingData.discount).toFixed(2)}}</p>
            </div>
        </div>
    </div>


          <div class="cabh_sect">
          <!-- <button mat-flat-button class="cccakl">Cancel</button> -->
          <button mat-flat-button color="accent" class="submit-btn" (click)="onPost()"
            [disabled]="isSubmitDisabled">Produce new bill</button>
        </div>
      </mat-card>


<!-- -------------------------------------------------------------------------------- -->
<!-- -------------------------------------------------------------------------------- -->
<!-- ------------------PRODUCE BILL SECTION FOR FITNESSS BELOW----------------------- -->
<!-- -------------------------------------------------------------------------------- -->
<!-- -------------------------------------------------------------------------------- -->


          <mat-card class="booking-form" *ngIf="selectedBusiness.revenue_model == 2">
            <div class="serv_heading">
              <h3>New bill for {{selectedBusiness.name}}</h3>
              <p>{{selectedBusiness.address_line}}</p>
          </div>
          <div class="form-group">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Name</mat-label>
              <input matInput [(ngModel)]="newbookingData.customerName" type="text" placeholder="Enter name" (keyup)="searchCustomerName($event)" [matAutocomplete]="auto">
              <button
            mat-button
            *ngIf="loaderForAutocomplete"
            matSuffix
            mat-icon-button
            aria-label="Clear"
          >
          <mat-progress-spinner
          diameter="20"
          mode="indeterminate"
          color="accent"
          strokeWidth="3"
          style="width: 20px; height: 20px;"
        > </mat-progress-spinner>
          </button>
              <mat-autocomplete #auto="matAutocomplete">
                <mat-option
                  *ngFor="let item of autocompleteItems"
                  (click)="selectSearchResult(item)"
                >
                  {{ item.name | titlecase }} ({{item.country_code}} {{item.phone}})
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
         
            <div class="c_sectionmj">
             <div class="row">
              <div class="col-sm-3">
                <mat-form-field appearance="outline" class="country-code">
                  <mat-label>Country Code</mat-label>
                  <mat-select
                  [(ngModel)]="selectedCountryCode"
                  required
                  (selectionChange)="onCountrySelected($event)"
                >
                  <mat-select-trigger>
                    {{ selectedCountryCode.flag }} {{ selectedCountryCode.name }}
                        {{ "(" + selectedCountryCode.dial_code + ")" }}
                  </mat-select-trigger>
                  
                  <mat-option>
                    <ngx-mat-select-search
                      noEntriesFoundLabel="no results found"
                      name="countrysearch"
                      placeholderLabel="Enter country name"
                      [formControl]="searchString"
                      (keyup)="onKey()"
                    ></ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let country of countryList" [value]="country">
                    {{ country.flag }} {{ country.name }}
                    {{ "(" + country.dial_code + ")" }}
                  </mat-option>
                </mat-select>
                </mat-form-field>
            </div>
            <div class="col-sm-9">
              <mat-form-field appearance="outline" class="phone-number">
                <mat-label>Phone</mat-label>
                <input [(ngModel)]="newbookingData.customerPh" matInput  placeholder="Enter phone" type="tel" smNumericOnly
                minLength="3"
                maxlength="17">
        <mat-hint style="color: red;
    font-size: 13px;" align="end" *ngIf="newbookingData.customerPh && newbookingData.customerPh != '' &&  newbookingData.customerPh.length < 3 ">Please enter a valid phone number in the range of 3-17.</mat-hint>
              </mat-form-field>
              </div>
            </div>
            </div>
          </div>
          <h3 class="servicet_heading">Service type</h3>
          <div class="form-group service-button">
            <mat-chip-list class="example-chip">
              <mat-chip *ngIf="selectedBusiness.shop_service_status != 2 && getSectionVisibleStatus('shop_invoice_access')" [ngClass]="{ 'Graceful-box-active': selectedServiceType == '1' }" (click)="changeServiceType('1')">In-premise service</mat-chip>
                <mat-chip *ngIf="selectedBusiness.home_service_status != 2 && getSectionVisibleStatus('home_invoice_access')" [ngClass]="{ 'Graceful-box-active': selectedServiceType == '0' }" (click)="changeServiceType('0')">Home service</mat-chip>
                <mat-chip *ngIf="selectedBusiness.virtual_service_status != 2 && getSectionVisibleStatus('virtual_invoice_access')" [ngClass]="{ 'Graceful-box-active': selectedServiceType == '2' }" (click)="changeServiceType('2')">Virtual service</mat-chip>
            </mat-chip-list>
              </div>
              
          <h3 class="servicet_heading">Date and time</h3>
              <div class="form-group date-buttons">
                <mat-chip-list class="example-chip">
                    <mat-chip  [ngClass]="{ 'Graceful-box-active': selectedBookingType == 1 }"
                    (click)="changeChip(1)">Today</mat-chip>
                    <mat-chip  [ngClass]="{ 'Graceful-box-active': selectedBookingType == 4 }"
                    (click)="changeChip(4)">Yesterday</mat-chip>
                    <mat-chip  [ngClass]="{ 'Graceful-box-active': selectedBookingType == 5 }"
                    (click)="onSelectDate()">{{ selectedDate && selectedBookingType == 5 ? (selectedDate | date : "longDate") : "Select Date" }}</mat-chip>
                    <mat-chip [ngClass]="{ 'Graceful-box-active': startTime && endTime }" (click)="onSelectSlot()" style="margin-left: 24px;">{{ (startTime && endTime) ? tConv24(startTime) + ' - ' + tConv24(endTime) : 'Select Slot' }}</mat-chip>
                  </mat-chip-list>
            </div>


            <!-- SERVICES  -->
      <div class="form-group shop_serv">
        <h3 class="servicet_heading">{{ selectedServiceType == "1" ? "In-premise services" : (selectedServiceType == "0" ? "Home services" : "Virtual services") }}</h3>
        <mat-chip-list class="example-chip" *ngIf="serviceList.length > 0">
          <div *ngFor="let item of serviceList">
            <mat-chip
              *ngIf="item.toShow"
              style="height: auto"
              (click)="selectServices(item)"
              >{{ item.serviceName }}
            </mat-chip>
          </div>
       

        </mat-chip-list>
        <p *ngIf="serviceList.length == 0">No service added</p>
    </div>
            <!-- PRODUCTS  -->
      <div class="form-group shop_serv" style="border-top: none;" *ngIf="productsList.length > 0">
        <h3 class="servicet_heading">Sellable products</h3>
        <mat-chip-list class="example-chip" *ngIf="productsList.length > 0">
          <div *ngFor="let item of productsList">
            <mat-chip
              *ngIf="item.toShow"
              style="height: auto"
              (click)="selectProducts(item)"
              >{{ item.product_name }}
            </mat-chip>
          </div>
       

        </mat-chip-list>
        <p *ngIf="productsList.length == 0">No product added</p>
    </div>
  
    <!-- SELECTED SERVICES -->
    <h3 *ngIf="completedJobs.length > 0">Job completed</h3>
    <div class="chip_cont">
      <div class="" *ngIf="completedJobs.length > 0">
       
        <div *ngFor="let item of completedJobs; let i = index;" style="margin-bottom: 30px;display: flex;
        justify-content: space-between;
        align-items: center;border-bottom: 1px solid #ddd;padding-bottom: 25px;">
          <div class="first_div">
            <div style="
                display: inline-block;
                width: fit-content;
                background: #ffc107;
                padding: 7px 12px;
                border-radius: 34px;
                margin-bottom: 20px; ">
              <p style="margin: 0px;font-weight: 500;">
                {{ item.service_name }}
              </p>
            </div>
            <mat-icon style="font-size: 20px;
            font-weight: 900;
            color: #000;
            position: relative;
            top: 4px;
            margin-left: 10px;">close</mat-icon>
            <div style="display: inline-block;">
              <span style="    margin-left: 10px;
              border: 1px solid #a2a2a2;
              padding: 10px;
              border-radius: 10px;">
                <button
                (click)="decreaseServiceCount(item,i)"
                style="background: none;
                border: 1px solid #a2a2a2;
                border-radius: 25px;
                width: 25px;
                height: 25px;">
                <mat-icon class="material-icons-outlined" style="    font-size: 16px;
                position: relative;
                top: 2px;
                left: -3px;
                color: #666666;
                height: auto;
                width: auto;">remove</mat-icon>
                </button>
                <span style="    margin: 0 15px;"> {{item.total_completed_services_qty}} </span>
                <button 
                (click)="increaseServiceCount(item,i)"
                style="background: none;
                border: 1px solid #a2a2a2;
                border-radius: 25px;
                width: 25px;
                height: 25px;">
                <mat-icon style="    font-size: 16px;
                position: relative;
                top: 2px;
                left: -3px;
                color: #666666;
                height: auto;
                width: auto;" class="material-icons-outlined">add</mat-icon>
                </button>
              </span>
              
              
            </div>
            <div *ngIf="selectedBusiness.is_owner == 1" >
                by <span style="
              text-decoration: underline; cursor: pointer;" (click)="assignEmployee(item,i)" >{{item.completed_by | arrayToStr | ellipsify:30}}</span>
  
              <span
              (click)="removeCompletedJobs(item)"
              style="
              margin-left: 20px;
              display: inline-block;
              cursor: pointer;">
                Remove
              </span>
              </div>
            <div *ngIf="selectedBusiness.is_owner == 0" style="
              text-decoration: underline; cursor: pointer;">
                
              <span
              (click)="removeCompletedJobs(item)"
              style="
              margin-left: 20px;
              display: inline-block;
              cursor: pointer;">
                Remove
              </span>
              </div>

          </div>
          <div class="second-div" style="padding: 0;">

            <!-- <div >
              <mat-form-field appearance="outline" style="width: 100px" class="small-height-input">
                <input [(ngModel)]="item.price" matInput smDecimalOnly type="number"  (ngModelChange)="changeServicePrice(item)"/>
              </mat-form-field>
            </div> -->
            <div class="th_heading">
              <input [(ngModel)]="item.price" matInput smDecimalOnly type="number"  (ngModelChange)="changeServicePrice(item)"/>
          </div>
        </div>

        </div>
      </div>
        

      </div>
 
  
    <!-- SELECTED PRODUCTS -->
    <h3 *ngIf="completedProducts.length > 0">Selected products</h3>
    <div class="chip_cont">
      <div class="" *ngIf="completedProducts.length > 0">
       
        <div *ngFor="let item of completedProducts; let i = index;" style="margin-bottom: 30px;display: flex;
        justify-content: space-between;
        align-items: center;border-bottom: 1px solid #ddd;padding-bottom: 25px;">
          <div class="first_div">
            <div style="
                display: inline-block;
                width: fit-content;
                background: #ffc107;
                padding: 7px 12px;
                border-radius: 34px;
                margin-bottom: 20px; ">
              <p style="margin: 0px;font-weight: 500;">
                {{ item.product_name }}
              </p>
            </div>
            <mat-icon style="font-size: 20px;
            font-weight: 900;
            color: #000;
            position: relative;
            top: 4px;
            margin-left: 10px;">close</mat-icon>
            <div style="display: inline-block;">
              <span style="    margin-left: 10px;
              border: 1px solid #a2a2a2;
              padding: 10px;
              border-radius: 10px;">
                <button
                (click)="decreaseProductCount(item,i)"
                style="background: none;
                border: 1px solid #a2a2a2;
                border-radius: 25px;
                width: 25px;
                height: 25px;">
                <mat-icon class="material-icons-outlined" style="    font-size: 16px;
                position: relative;
                top: 2px;
                left: -3px;
                color: #666666;
                height: auto;
                width: auto;">remove</mat-icon>
                </button>
                <span style="    margin: 0 15px;"> {{item.total_completed_services_qty}} </span>
                <button 
                (click)="increaseProductCount(item,i)"
                style="background: none;
                border: 1px solid #a2a2a2;
                border-radius: 25px;
                width: 25px;
                height: 25px;">
                <mat-icon style="    font-size: 16px;
                position: relative;
                top: 2px;
                left: -3px;
                color: #666666;
                height: auto;
                width: auto;" class="material-icons-outlined">add</mat-icon>
                </button>
              </span>
              
              
            </div>
            <div style="
              text-decoration: underline; cursor: pointer;">
                <!-- by <span (click)="assignEmployee(item,i)" >{{item.completed_by | arrayToStr | ellipsify:30}}</span> -->
  
              <span
              (click)="removeCompletedProducts(item)"
              style="
              margin-left: 20px;
              display: inline-block;
              cursor: pointer;">
                Remove
              </span>
              </div>

          </div>
          <div class="second-div" style="padding: 0;">

            <!-- <div >
              <mat-form-field appearance="outline" style="width: 100px" class="small-height-input">
                <input [(ngModel)]="item.price" matInput smDecimalOnly type="number"  (ngModelChange)="changeServicePrice(item)"/>
              </mat-form-field>
            </div> -->
            <div class="th_heading">
              <input [(ngModel)]="item.price" matInput smDecimalOnly type="number"  (ngModelChange)="changeServicePrice(item)"/>
          </div>
        </div>

        </div>
      </div>
        

      </div>



      <!-- new section added start -->
      <!-- -->
   
    <!-- <div style="border-bottom: 1px solid lightgray;">
        <div class="row" style="margin-bottom: 20px; padding: 0 18px 0 0">
            <div class="col-sm-10" style="font-size: 16px;">Total</div>
            <div class="col-sm-2" style="text-align: right; font-size: 16px;">
              
    
                  {{newbookingData.price}}
                </div>
         
        </div>
        <div class="row" style="padding: 0 18px 0 0;">
            <div class="col-sm-10" style="font-size: 16px;">Discount</div>
            <div class="col-sm-2" style="text-align: right;">
                <mat-form-field appearance="outline" style="width: 100px" class="small-height-input">
                    <input [(ngModel)]="newbookingData.discount" matInput smDecimalOnly type="number" />
                  </mat-form-field>
                </div>
         
        </div>
       
    </div> -->

    <!-- <div>
        <div class="row" style="margin-top: 20px; margin-bottom: 40px; padding: 0 18px 0 0">
            <div class="col-sm-10" style="font-size: 16px;">Net payable</div>
            <div class="col-sm-2" style="text-align: right; font-size: 16px;">
             
    
                  {{newbookingData.price - newbookingData.discount}}
                </div>
         
        </div>
    </div> -->
    

   <!-- create invice new design added -->
   <div class="other_itemi_secty">
    <div class="oth_headingrt">
      <h3>Other item</h3>
    </div>
    <!-- <div class="repect_under" *ngFor="let item of repeatArray; let i = index">
    <div class="row">
      <div class="col-sm-6">
        <div class="item_name_tht">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Item name</mat-label>
              <input matInput type="text" placeholder="Enter item name">
            </mat-form-field>
        </div>
      </div>

      <div class="col-sm-6">
        
        <div class="plus_tht" style="padding-top: 14px;">
          <mat-icon class="serv_x">close</mat-icon>
          <div class="inc_dec_cont">
            <span class="cont_span">
              <button class="inc_dec_btn">
              <mat-icon >remove</mat-icon>
              </button>
              <span style="margin: 0 15px;"> 1 </span>
              <button 
              class="inc_dec_btn">
              <mat-icon class="material-icons-outlined">add</mat-icon>
              </button>
            </span>
            <span class="remove_btn" (click)="removeFormField(i)">Remove</span>
          </div>
        </div>

      </div>
    </div>
  </div>
 
    <div class="add_item_btbh">
      <button mat-flat-button color="accent" (click)="addFormField()">
        <mat-icon>add</mat-icon>
        Add item
      </button>
    </div> -->

    <form [formGroup]="form">
      <div formArrayName="items">
        <div *ngFor="let item of items.controls; let i = index" [formGroupName]="i" class="repect_under">
          <div class="row">
            <div class="col-sm-3">
              <div class="item_name_tht">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Item name</mat-label>
                  <input matInput formControlName="name" [matAutocomplete]="auto" type="text" placeholder="Enter item name">
                  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayItemName">
                    <mat-option *ngFor="let option of filteredOptions[i] | async" [value]="option">
                      {{ option.item_name }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="plus_tht" style="padding-top: 14px;">
                <mat-icon class="serv_x">close</mat-icon>
                <div class="inc_dec_cont">
                  <span class="cont_span">
                    <button type="button" class="inc_dec_btn"  (click)="decreaseCount(i)">
                      <mat-icon>remove</mat-icon>
                    </button>
                    <span style="margin: 0 15px;">{{ item.get('count')!.value }}</span>
                    <button type="button" class="inc_dec_btn"  (click)="increaseCount(i)">
                      <mat-icon>add</mat-icon>
                    </button>
                  </span>
                </div>
              </div>
            </div>
            <div class="col-sm-3">
              
              <mat-form-field appearance="outline" >
                <mat-select class="w-100" formControlName="tax_slab">
                  <mat-option value="default" >
                    Select a tax
                  </mat-option>
                  <mat-option [value]="item.hash_id" *ngFor="let item of taxSlabData">
                    {{isEntityForeign == '0' ? item.tax_name : item.slab_name}}
                  </mat-option>
                  
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-sm-3">
              <div class="item_name_tht">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Item price</mat-label>
                  <input matInput formControlName="price" type="text" placeholder="Enter item price" smDecimalOnly type="number">
                </mat-form-field>
              </div>
            </div>
            <span class="remove_btn">
              <a (click)="removeFormField(i)" style="color: #222;"> Remove</a>
          </span>
            <!-- (click)="removeFormField(i)" -->
          </div>
        </div>
      </div>
    
      <div class="add_item_btbh">
        <button type="button" mat-flat-button color="accent" (click)="addFormField()">
          <mat-icon>add</mat-icon>
          Add item
        </button>
      </div>
    </form>
    

  </div>


  <!-- create invice new design end -->


     <div class="new_prodcutht">
        <div class="tota_price_s">
            <div class="th_heading">
                <p class="tog_section">Total</p>
            </div>
            <div class="th_heading">
                <p class="tog_section">{{newbookingData.price.toFixed(2)}}</p>
            </div>
        </div>

        <div class="tota_price_s">
            <div class="th_heading">
                <p class="tog_section">Discount</p>
            </div>
            <div class="th_heading">
                <input [(ngModel)]="newbookingData.discount" smDecimalOnly type="number" matInput />
            </div>
        </div>
     </div>
     <div class="net_payble_se">
        <div class="tota_price_s">
            <div class="th_heading">
                <p>Net payable</p>
            </div>
            <div class="th_heading">
                <p>{{(newbookingData.price - newbookingData.discount).toFixed(2)}}</p>
            </div>
        </div>
    </div>


          <div class="cabh_sect">
          <!-- <button mat-flat-button class="cccakl">Cancel</button> -->
          <button mat-flat-button color="accent" class="submit-btn" (click)="onPostForFitness()"
            [disabled]="isSubmitDisabled">Produce new bill</button>
        </div>
      </mat-card>
      </div>
    
        <div class="col-md-4 booking-sidebar">
          <div class="faq">
            <mat-accordion>
             <mat-expansion-panel [expanded]="panelState[0]"  (opened)="panelState[0] = true"
                                  (closed)="panelState[0] = false">
               <mat-expansion-panel-header>
                 <mat-panel-title>
                  Are name and phone number mandatory?
   
                 </mat-panel-title>
                
               </mat-expansion-panel-header>
               <p>They are optional. If you are in a hurry, you can leave them blank. But to keep record of your customers, their spending, dues and to communicate, we recommend to add name and phone number.
               </p>
             </mat-expansion-panel>
             <!-- <mat-expansion-panel (opened)="panelState[1] = true"
                                  (closed)="panelState[1] = false">
               <mat-expansion-panel-header>
                 <mat-panel-title>
                  Why the 'Produce new bill' button is disabled?
   
                 </mat-panel-title>
                
               </mat-expansion-panel-header>
               <p>Check whether services are added against the business. Once they are added, the chips of services will appear here too. For creating a new booking you have to select at least one chip from the list.
               </p>
             </mat-expansion-panel> -->
             <mat-expansion-panel (opened)="panelState[1] = true"
             (closed)="panelState[1] = false">
<mat-expansion-panel-header>
<mat-panel-title>
  Where can I see the invoices?

</mat-panel-title>

</mat-expansion-panel-header>
<p>Go to the specific Booking section of that business's details page. Select the booking and see the booking details. If all tasks are 'Done', there's option to see the invoice. In 'All bookings/Queries' and in the 'Bills/Invoices' section, you can see the raised invoices.
</p>
</mat-expansion-panel>
             <mat-expansion-panel (opened)="panelState[2] = true"
                                  (closed)="panelState[2] = false">
               <mat-expansion-panel-header>
                 <mat-panel-title>
                  Does a new bill also creates a new booking?
   
                 </mat-panel-title>
                
               </mat-expansion-panel-header>
               <p>Yes. A new booking created with all the customer and service data automatically.
               </p>
             </mat-expansion-panel>
             <mat-expansion-panel (opened)="panelState[3] = true"
                                  (closed)="panelState[3] = false">
               <mat-expansion-panel-header>
                 <mat-panel-title>
                  Where can I see the invoices?
   
                 </mat-panel-title>
                
               </mat-expansion-panel-header>
               <p>Go to the specific Booking section of that business's details page. Select the booking and see the booking details. There's an option to see the invoice in that detail screen. Also 'Reports' section having a dedicated invoice segment.
               </p>
             </mat-expansion-panel>
             <mat-expansion-panel (opened)="panelState[4] = true"
                                  (closed)="panelState[4] = false">
               <mat-expansion-panel-header>
                 <mat-panel-title>
                  Why owner name coming with the added services?
   
                 </mat-panel-title>
                
               </mat-expansion-panel-header>
               <p>The platform keep track the task assignment to employees, their performance and revenue generation by them. By default the owner name appears as the service performer. If you have added employees, then you can change the assignment and manage according to you.
               </p>
             </mat-expansion-panel>
   
          
           </mat-accordion>
           
  
          </div>
        </div>
      </div>
    
     <!-- Placeholder design html start -->
      <!-- <div class="placeholder_started">
        <div class="row">
          <div class="heading_sert">
            <h3>Produce bill</h3>
        </div>
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/bills.png">
                 </div>
                 <mat-card-title>No business added yet</mat-card-title>
                 <mat-card-content>To generate a new invoice, you need to create a business first. Invoices will be added and listed under that business.
                </mat-card-content>
                 <div class="create_btnyh">
                    <button mat-flat-button color="primary">
                        <mat-icon>add</mat-icon> 
                        Create new 
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/watchvideo.png">
                 </div>
                 <mat-card-title>How to generate invoice?</mat-card-title>
                 <mat-card-content>Check our <span class="ghtunderline">help document<span> on producing a new invoice against a business. You can check this video as well.
                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary">
                       <mat-icon>play_arrow</mat-icon>
                       Watch video
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/helpsupport.png">
                 </div>
                 <mat-card-title>Having any issue?</mat-card-title>
                 <mat-card-content>For any difficulties in adding a new booking or if there's any issue while adding them, contact our support team.
                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary">
                       <mat-icon>support_agent</mat-icon>
                       Contact support 
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
        </div>
    
      </div> -->
      <!-- Placeholder design html start -->


    
    
    </div>
<div class="booking-container" *ngIf="!loader && businessListData.length == 0">

 
    
     <!-- Placeholder design html start -->
      <div class="placeholder_started">
        <div class="row">
          <div class="heading_sert">
            <h3>Produce Bill / Invoice</h3>
        </div>
          <div class="col-sm-4" *ngIf="!isEmployeeAndHasBusinessButDoesNotHaveAccess">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/business-create.png" style="width: 110px;">
                 </div>
                 <mat-card-title>No business added yet</mat-card-title>
                 <mat-card-content>To generate a new invoice, you need to create a business first. Invoices will be added and listed under that business.
                </mat-card-content>
                 <div class="create_btnyh">
                    <button mat-flat-button color="primary" (click)="selectcountry()">
                        <mat-icon>add</mat-icon> 
                        Create a business 
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
          <div class="col-sm-4" *ngIf="isEmployeeAndHasBusinessButDoesNotHaveAccess">
            <div class="dashboard_new" >
              <mat-card appearance="outlined" style="">
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/business-create.png" style="width: 110px;">
                 </div>
                 <mat-card-title>Access denied.</mat-card-title>
                 <mat-card-content> Business owner with valid premium business subscription or an active employee with permission can access this section. Check current plans. Recharge pack if expired.
                </mat-card-content>
                 
                 </div>
              </mat-card>
           </div>
          </div>
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/invoice-c1.png">
                 </div>
                 <mat-card-title>How to generate invoice?</mat-card-title>
                 <mat-card-content>Check our <span class=""><a href="https://lookzup.com/help" target="_blank" class="ghtunderline"> help document </a></span> on producing a new invoice against a business. You can check this video as well.
                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary" (click)="openvideo()">
                       <mat-icon>play_arrow</mat-icon>
                       Watch video
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/helpsupport.png">
                 </div>
                 <mat-card-title>Having any issue?</mat-card-title>
                 <mat-card-content>
                  For any difficulties in creating a new invoice or if there's any issue while sharing them, contact our support team.
                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary" (click)="opencontact()">
                       <mat-icon>support_agent</mat-icon>
                       Contact support 
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
        </div>
    
      </div>
      <!-- Placeholder design html start -->


    
    
    </div>
    